export const API_END_POINT = process.env.REACT_APP_API_END_POINT;
export const GRAPHQL_END_POINT = process.env.REACT_APP_GRAPHQL_END_POINT;
export const IMAGE_END_POINT = process.env.REACT_APP_IMAGE_END_POINT;
